<template>
  <div class="view-jd-price-list">
    <navbar :title="title" class="nav-bar" left-text show-home />
    <div class="product-list" v-show="skuList.length">
      <div
        :key="index"
        class="product-details van-hairline--bottom"
        v-for="(sku, index) in skuList"
      >
        <a
          @click="
            jumpDetails(sku.item_id, sku.sku_id, sku.platform, sku.item_type)
          "
          class="jump-details"
          href="javascript:;"
        >
          <div class="sku-details">
            <div class="sku-img van-hairline--surround">
              <img :key="sku.sku_id" v-lazy="sku.pic_url" />
              <div class="sku-img-mask" v-show="sku.problem">
                {{ sku.problem }}
              </div>
            </div>
            <div class="sku-intro">
              <div class="sku-title">{{ sku.name }}</div>
              <div class="sku-desc">
                <div class="sku-name" v-show="sku.attr_list">
                  <span>
                    <em :key="index" v-for="(item, index) in sku.attr_list">{{
                      item.attr_value.value
                    }}</em>
                  </span>
                </div>
                <div class="sku-num">数量: {{ sku.number }}</div>
              </div>
              <div
                @click.stop="jumpJdLink(sku.sku_id)"
                class="sku-link"
                v-show="title"
              >
                <button>{{ title }}格</button>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import api from '../utils/api'
let flag = false
export default {
  name: 'viewJdPirce',
  components: {
    Navbar
  },
  data () {
    return {
      skuList: []
    }
  },
  computed: {
    title () {
      if (this.$route.query.platform === 'jd') {
        return '查看京东价'
      } else if (this.$route.query.platform === 'yanxuan') {
        return '查看网易价'
      } else if (this.$route.query.platform === 'suning') {
        return '查看苏宁价'
      } else {
        return ''
      }
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getShopingCartList().then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    // https://ab.buslive.cn/yunku/jump/detail?sku_id=200021 跳转京东规则

    /**
     * 获取购物车列表
    */
    async getShopingCartList () {
      const res = await this.$axios.get('api/cart/2.0/list')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.skuList = data.cart.find(platform => platform.platform.name === this.$route.query.platform).sku_list
        } else if (code === 9006) {
        } else {
          this.$toast(msg)
        }
      }
    },
    /**
     * 跳转到商品详情
    */
    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    },
    jumpJdLink (skuid) {
      location.href = `https://ab.buslive.cn/yunku/jump/detail?sku_id=${skuid}`
    }
  }
}
</script>

<style lang="less" scoped>
.product-list {
  padding: 0 0.2rem 0.4rem;
  background-color: #fff;
}
.product-details {
  .flex-between;
  .jump-details {
    padding-top: 0.4rem;
    // padding-bottom: 0.57rem;
    width: 6.64rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .sku-details {
    position: relative;
    padding: 0.24rem 0;
    width: 100%;
    display: flex;
    .sku-img {
      width: 1.6rem;
      height: 1.6rem;
      margin: 0 0.2rem;
      img {
        object-fit: contain;
      }
    }
    .sku-img-mask {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 1.08rem;
      height: 1.08rem;
      font-size: @fz20;
      color: #fff9f9;
      border-radius: 50%;
      .flex-center;
      background-color: rgba(0, 0, 0, 0.7);
    }
    .sku-intro {
      width: 4.8rem;
      .sku-title {
        .ellipsis2;
        font-size: @fz24;
        color: @sku-tit;
      }
      .sku-desc {
        padding-top: 0.2rem;
        .flex-between;
        .sku-name {
          width: 3.5rem;
          font-size: @fz20;
          color: #b8b8b8;
          display: flex;
          span {
            .ellipsis1;
            padding: 0.05rem 0.08rem;
            background-color: #f5f5f5;
            box-sizing: border-box;
            border: 0.5px solid #cbcbcb;
            border-radius: 0.05rem;
          }
        }
        .sku-num {
          font-size: @fz24;
          color: #403232;
        }
      }

      .sku-link {
        position: relative;
        margin-top: 0.5rem;
        font-size: @fz24;
        color: #ff2851;
        padding-left: 0.5rem;
        padding-bottom: 0.22rem;
        &::after {
          position: absolute;
          content: '';
          left: 0rem;
          top: 0;
          // transform: translateY(-50%);
          width: 0.35rem;
          height: 0.35rem;
          background: url('../assets/img/link-icon.png') center no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
</style>
